import { render, staticRenderFns } from "./LinkExpiredPage.vue?vue&type=template&id=4d737e19&"
import script from "./LinkExpiredPage.vue?vue&type=script&lang=js&"
export * from "./LinkExpiredPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports